var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, getTypography } from '@creditas-ui/react';
export var SelectButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 10px 0;\n  font: inherit;\n  cursor: pointer;\n\n  :hover {\n    button {\n      background-color: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 10px 0;\n  font: inherit;\n  cursor: pointer;\n\n  :hover {\n    button {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[10];
});
export var OptionsContainer = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 1;\n  position: absolute;\n  list-style-type: none;\n  margin-top: ", ";\n  padding: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  max-width: ", ";\n  width: ", ";\n"], ["\n  z-index: 1;\n  position: absolute;\n  list-style-type: none;\n  margin-top: ", ";\n  padding: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  max-width: ", ";\n  width: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacingTop.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacingX.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[0];
}, function (_a) {
    var theme = _a.theme;
    return theme.radius['2xl'];
}, function (_a) {
    var theme = _a.theme;
    return theme.shadow.sm;
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return "".concat(maxWidth, "px");
}, function (_a) {
    var width = _a.width;
    return (width ? "".concat(width, "px") : 'auto');
});
export var Option = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  padding: ", " 0;\n  padding-left: ", ";\n  padding-right: ", ";\n  color: ", ";\n\n  ", "\n"], ["\n  cursor: pointer;\n  padding: ", " 0;\n  padding-left: ", ";\n  padding-right: ", ";\n  color: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacingX['5xl'];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacingLeft['5xl'];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacingLeft['9xl'];
}, function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    return isSelected ? theme.colors.neutral[90] : theme.colors.neutral[60];
}, getTypography('bodySmRegular'));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Select.styles.js.map